/**
 * ## Overview
 *
 * This file should be considered a "temporary solution" (which probably will stick around for a while)
 * for the following scenarios:
 *
 * - Categories of CSS properties for which we don't have token support yet (e.g. dimensions)
 * - Specific CSS values for which we have token support but we don't have the necessary values (e.g. font-size: 15px)
 *
 *  Instead of hardcoding these values directly in components, the plan is to centralise these in a
 * "single source of truth" which will allow us to have better governance over these values over time.
 *
 * ## Deprecating properties
 *
 * After working with UX to identify tokens that are likely missing, if the missing token gets added, please
 * remove from this file all values that can now be replaced with that token.
 *
 * @see https://git.hubteam.com/HubSpot/foundations-components/issues/5943
 */

export const HEIGHT = {
  ACTIONS_MENU_MENU_OPTION: '24px',
  CAROUSEL_ASPECT_RATIO: '0px',
  CAROUSEL_THUMBNAIL_IMAGE_WRAPPER: '0px',
  HEADER_PSEUDO_BORDER: '1px',
  HR: '1px',
  SELECT_MENU_INPUT: '40px',
  TEXT_AREA_FIELDSET_SMALL: '32px',
  TEXT_AREA_INPUT: '40px'
};
export const MIN_HEIGHT = {
  BADGE: '20px',
  CHEVRON_OUTER_WRAPPER_DOWN: '60px',
  CHEVRON_OUTER_WRAPPER_RIGHT: '40px',
  HEADER_DETAILS: '1px',
  HEADER_INNER_WRAPPER: '32px',
  HR: '1px',
  TOGGLE_INPUT_WRAPPER: '32px',
  TOOLBAR: '56px'
};
export const MIN_WIDTH = {
  CHEVRON_OUTER_WRAPPER_DOWN: '60px',
  FIELDSET_OUTER_WRAPPER: '0px',
  PANEL_CONTAINER: '300px',
  TRUNCATE_STRING: '0px'
};
export const PADDING = {
  EXPANDABLE_CONTENTS_PADDING_INLINE_DEFAULT: '44px',
  SELECTABLE_BUTTON_PADDING_LEFT: '30px',
  DATE_TIME_ICON_PADDING_LEFT: '24px',
  MICRO_DATE_TIME_INPUT_ICON_PADDING_LEFT: '16px'
};
export const LINE_HEIGHT = {
  BADGE: '20px'
};
export const FONT_SIZE = {
  BADGE: '10px'
};
export const WIDTH = {
  TOOLTIP_FLOATING_ARROW: '20px',
  COLOR_INPUT_INLINE_SIZE: '115px',
  COLOR_INPUT_OPACITY_INPUT_INLINE_SIZE: '110px',
  MOVEABLE_AREA_DRAG_HANDLE: '26px'
};

/**
 * Size should be used when two dimension specific properties are the same:
 *
 * - width and height
 * - height and min-height
 * - width and min-width
 */
export const SIZE = {
  BADGE_DOT: '12px',
  BADGE_MIN_SIZE: '23px',
  BREADCRUMBS_ICON: '8px',
  CHECKBOX_WRAPPER_WITH_CHILDREN: '20px',
  HR: '1px',
  SCREEN_READER_ONLY: '1px',
  SELECT_CHECKBOX_SIZE: '16px'
};
export const SELECT = {
  BORDER_WIDTH: '6px',
  MARGIN_BLOCK_START: '6px'
};